import ChargerPageTemplate from '@/components/seo/ChargerPageTemplate';
import { getRichPage } from '@/components/seo/rich';
import CompetitorVsEnkel from '@/components/seo/rich/pages/CompetitorVsEnkel';
import CityPricingRich from '@/components/seo/rich/pages/CityPricingRich';
import BestListRich from '@/components/seo/rich/pages/BestListRich';
import EvModelRich from '@/components/seo/rich/pages/EvModelRich';
import GuideRich from '@/components/seo/rich/pages/GuideRich';
const templates = {city_pricing: CityPricingRich, region_pricing: CityPricingRich, best_list: BestListRich, ev_model: EvModelRich, charger_product: ChargerPageTemplate, competitor_comparison: CompetitorVsEnkel};
export default function SeoPageContent({ page }) {
  const Content = getRichPage(page.slug) || templates[page.page_type] || GuideRich;
  return <div className="customer-seo-page"><Content page={page} /></div>;
}